import Toast from './Toast'
import Toasts from './Toasts'
import ToastLink from './ToastLink'

export { Toast, ToastLink }

export default Object.assign(Toasts, {
  Toast,
  Link: ToastLink,
})
